export type GtmPageKey = 'home' | 'srp' | 'vdp';

const PAGE_KEYS_BY_SEGMENT = new Map<string, GtmPageKey>([
  ['', 'home'],
  ['cars', 'srp'],
  ['vehicle', 'vdp']
]);

export default function emitGtmSpaPageview(
  previousSegment: string,
  currentSegment: string,
  fullPath: string,
  previousFullPath: string
) {
  const pageKey = PAGE_KEYS_BY_SEGMENT.get(currentSegment);
  const previousPageKey = PAGE_KEYS_BY_SEGMENT.get(previousSegment);

  if (
    !pageKey ||
    !previousPageKey ||
    pageKey === previousPageKey ||
    !previousFullPath
  ) {
    return;
  }

  const previousUrl = window.location.origin + previousFullPath;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'spaRouteChange',
    pageKey,
    path: fullPath,
    previousUrl
  });
}
